import {
    Box,
    Button,
    HStack,
    Progress,
    Text,
    VStack,
} from "@chakra-ui/react";
import {
    ArrowUpRight,
    Star,
} from "lucide-react";

import Card from "../../Dashboard/components/Card";

const Metric = ({
    label,
    value,
    progress,
}) => (
    <Box w="100%">
        <HStack
            justify="space-between"
            mb={2}
        >
            <Text
                color="gray.500"
                fontSize="sm"
            >
                {label}
            </Text>

            <Text
                fontWeight="700"
                color="#2453FF"
            >
                {value}
            </Text>
        </HStack>

        <Progress.Root
            value={progress}
            size="sm"
            borderRadius="full"
        >
            <Progress.Track bg="#E8EEFF">
                <Progress.Range bg="#2453FF" />
            </Progress.Track>
        </Progress.Root>
    </Box>
);

const MarketplaceCard = () => {
    return (
        <Card h="100%">
            <Text
                fontSize="xl"
                fontWeight="700"
                color="#071D54"
                mb={6}
            >
                Marketplace Standing
            </Text>

            <VStack
                gap={6}
                align="stretch"
            >
                <Metric
                    label="Response Rate"
                    value="98%"
                    progress={98}
                />

                <Metric
                    label="Completion Rate"
                    value="94%"
                    progress={94}
                />

                <Box>
                    <Text
                        color="gray.500"
                        fontSize="sm"
                        mb={2}
                    >
                        Customer Rating
                    </Text>

                    <HStack
                        justify="space-between"
                    >
                        <HStack gap={1}>
                            {[1, 2, 3, 4, 5].map(
                                (star) => (
                                    <Star
                                        key={star}
                                        size={18}
                                        fill="#FACC15"
                                        color="#FACC15"
                                    />
                                )
                            )}
                        </HStack>

                        <Text
                            fontWeight="700"
                            color="#2453FF"
                        >
                            4.9/5
                        </Text>
                    </HStack>
                </Box>

                <Box
                    bg="#F8FAFC"
                    borderRadius="12px"
                    p={4}
                >
                    <Text
                        fontWeight="600"
                        color="#071D54"
                    >
                        Partner Level
                    </Text>

                    <Text
                        mt={1}
                        color="gray.500"
                        fontSize="sm"
                    >
                        Gold Partner
                    </Text>
                </Box>

                <Button
                    mt={2}
                    w="100%"
                    bg="#2453FF"
                    color="white"
                    _hover={{
                        bg: "#1E46D8",
                    }}
                >
                    View Performance Report

                    <ArrowUpRight
                        size={18}
                    />
                </Button>
            </VStack>
        </Card>
    );
};

export default MarketplaceCard;